export const sanitizeFieldInput = async (fieldProps, sanitizeAllWhiteSpaces = false) => {
  if (fieldProps.value) {
    let sanitizedString =  sanitizeValue(fieldProps.value, sanitizeAllWhiteSpaces);
    let event = { target: { value: sanitizedString } };
    if (typeof fieldProps.onChange === "function")
    await fieldProps.onChange(event);
  }
}

export const sanitizeValue = (value, sanitizeAllWhiteSpaces = false) => {
  let sanitizedString =  value.toString().replace(/\s+/g, ' ').trim();
    
  if (sanitizeAllWhiteSpaces) {
    sanitizedString = sanitizedString.toString().replace(/\s+/g, '');
  }

  return sanitizedString;
}